<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// This is Q18 is used only for call survey.
export default defineComponent({
  name: 'SurveyQ18',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('survey_18_checkbox_0'), key: '0' },
        { text: this.$t('survey_18_checkbox_1'), key: '1' },
        { text: this.$t('survey_18_checkbox_2'), key: '2' }
      ]
    };
  },
  computed: {
    ...mapGetters(['literacy'])
  },
  methods: {
    ...mapActions(['changeLiteracy']),

    change (event: number) {
      this.changeLiteracy(this.data[event].text);
    },
    findValue () {
      const filteredItems = this.data.filter(item => item.text === this.literacy);
      if (filteredItems.length > 0) {
        return filteredItems[0].key;
      } else {
        return '';
      }
    },
    nextScreen () {
      router.push({ path: '/survey/question19/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ $t('survey_18') }}</p>
      <radio-button :text="data" @change="change($event)" :value="findValue()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
